const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20}
    height={20}
    viewBox="0 0 512 512"
    fill="black"
    style={{ cursor: "pointer" }}
    {...props}
  >
    <path d="M512 59.076 452.922 0 256 196.922 59.076 0 0 59.076 196.922 256 0 452.922 59.076 512 256 315.076 452.922 512 512 452.922 315.076 256z" />
  </svg>
);
export default CloseIcon;
